import { Column, TableCollectionTemplate } from "../../collection/base-templates/table/table.model";
import { Action } from "../../collection/collection.model";
import { exportAction, menuAction, removeAction, getExportAction, getRemoveAction } from "../../collection/collection.data";
import { GridCollectionTemplate } from "../../collection/base-templates/grid/grid.model";

export const getTemplateSelectorTableActiveColumns = (): Column[] => [
	{
		id: 'name',
		name: $localize`:Table Name Column Label@@tableColumnNameLabel:Name`,
		path: 'name',
		type: 'field',
		width: 400,
		linked: {
			routerLink: ['']
		}
	},
	{
		id: 'modified',
		name: $localize`:Table Last Modified Column Label@@tableColumnLastModifiedLabel:Last Modified`,
		path: 'modified',
		type: 'date',
		width: 175,
		linked: {
			routerLink: ['']
		}
	},
	{
		id: 'numberOfSizes',
		name: $localize`:Table Number of Sizes Column Label@@tableColumnNumberOfSizesLabel:Number of Sizes`,
		path: 'creativeUnitsNames',
		type: 'custom',
		valueFn: entity => entity.creativeUnitsNames.length,
		width: 175,
		linked: {
			routerLink: ['']
		},
		disableSort: true
	},
	{
		id: 'createdByUserId',
		name: $localize`:Table Last Modified By Column Label@@tableColumnLastModifiedByLabel:Last Modified By`,
		path: 'createdByUser',
		type: 'custom',
		valueFn: ({ createdByUser }) => createdByUser?.fullName || createdByUser?.email,
		width: 250,
		linked: {
			routerLink: ['']
		}
	},
	{
		id: 'description',
		name: $localize`:Table Status Description Label@@tableColumnDescriptionLabel:Description`,
		path: 'description',
		type: 'field',
		width: 450,
		linked: {
			routerLink: ['']
		}
	},
	{
		id: 'businesses',
		name: $localize`:Table Businesses Column Label@@tableColumnBusinessesLabel:Businesses`,
		path: 'businesses',
		type: 'custom',
		valueFn: entity => entity?.creativePackageBusinesses?.map((b: any) => b?.name).filter(Boolean).join(', ') || $localize`:Asset Collections Table All Businesses@@assetCollectionsTableAllBusinesses:All`,
		width: 260,
		disableSort: true
	},

];

// separated so we have extra options in filter-bar -> showColumnsSelectButton
export const getAllTemplateSelectorTableColumns = () => {
	const columns = getTemplateSelectorTableActiveColumns();
	columns.unshift({
		id: 'id',
		name: $localize`:Table Status ID Label@@tableColumnIDLabel:Latest Published ID`,
		path: 'latestPublishedVersionId',
		type: 'field',
		width: 400
	})

	return columns;
};

export const getPackageMenuActions = (): Action[] => [
	{ ...menuAction,
		actionSettings: [
			{...getExportAction(), method: undefined },
			{...getRemoveAction(), method: 'remove' }
		]
	}
];

// Backward compatibility
export const packageMenuActions: Action[] = getPackageMenuActions();

export const getTemplateSelectorTableCollectionTemplate = (showPackageMenuActions: boolean = false, showColumnsSelectButton = false): TableCollectionTemplate => {
	return {
		id: 'template-selector-table',
		slug: 'table',
		name: 'Table',
		settings: {
			filterSidebar: false,
			showColumnsSelectButton,
			defaultLimit: 25,
			limitOptions: [5, 10, 25, 50],
			columns: getAllTemplateSelectorTableColumns(),
			activeColumns: getTemplateSelectorTableActiveColumns(),
			actions:  showPackageMenuActions ? getPackageMenuActions() : []
		}
	}
};

export const getTemplateSelectorGridCollectionTemplate = (): GridCollectionTemplate => {
	return {
		id: 'templates-grid',
		slug: 'grid',
		name: 'Grid',
		settings: {
			defaultLimit: 9,
			limitOptions: [6, 9, 15, 24]
		}
	}
};
